

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';

// const BookNow = () => {
//   const [services, setServices] = useState([]);
//   const [selectedService, setSelectedService] = useState('');
//   const [selectedDate, setSelectedDate] = useState('');
//   const [selectedHour, setSelectedHour] = useState('1');
//   const [selectedMinute, setSelectedMinute] = useState('00');
//   const [selectedPeriod, setSelectedPeriod] = useState('AM');
//   const [comments, setComments] = useState('');
//   const [home, setHome] = useState('');

//   useEffect(() => {
//     // Fetch the services from the API
//     axios.get('https://feniceshieldchemical.bwsoft.in/api/api/services/')
//       .then(response => {
//         setServices(response.data);
//       })
//       .catch(error => {
//         console.error('Error fetching services:', error);
//       });
//   }, []);

//   const convertTimeTo24Hour = (hour, minute, period) => {
//     let hours = parseInt(hour, 10);

//     if (period === 'PM' && hours < 12) {
//       hours += 12;
//     } else if (period === 'AM' && hours === 12) {
//       hours = 0;
//     }

//     return `${hours.toString().padStart(2, '0')}:${minute}`;
//   };

//   const handleSubmit = (event) => {
//     event.preventDefault();

//     // Convert the selected time to 24-hour format before sending to the backend
//     const time24 = convertTimeTo24Hour(selectedHour, selectedMinute, selectedPeriod);

//     const bookingData = {
//       service_id: selectedService,
//       service_date: selectedDate,
//       service_time: time24, // Converted time in 24-hour format
//       comments: comments,
//       home: home
//     };

//     axios.post('https://feniceshieldchemical.bwsoft.in/api/api/book-now', bookingData)
//       .then(response => {
//         alert('Booking successful');
//       })
//       .catch(error => {
//         console.error('Error submitting booking:', error);
//       });
//   };

//   return (
//     <div>
//       <div className="banner">
//         <img src="assets/img/about.jpg" alt="About" />
//       </div>

//       <div className="container">
//         <div className="row">
//           <div className="col-md-12">
//             <form onSubmit={handleSubmit}>
//               <h1>Book Service</h1>

//               <fieldset>
//                 <label htmlFor="job">Select service</label>
//                 <select id="job" name="user_job" value={selectedService} onChange={(e) => setSelectedService(e.target.value)}>
//                   <optgroup label="Services">
//                     {services.length > 0 ? (
//                       services.map(service => (
//                         <option key={service.id} value={service.id}>
//                           {service.name}
//                         </option>
//                       ))
//                     ) : (
//                       <option>Loading services...</option>
//                     )}
//                   </optgroup>
//                 </select>

//                 <legend>
//                   <span className="number">1</span> Fill the form
//                 </legend>

                

//                 <label htmlFor="comments">Comments</label>
//                 <input type="text" id="comments" name="comments" value={comments} onChange={(e) => setComments(e.target.value)} required />

//                 <label htmlFor="home">Home</label>
//                 <input type="email" id="home" name="home" value={home} onChange={(e) => setHome(e.target.value)} required />

//                 <label htmlFor="bio">Address</label>
//                 <textarea id="bio" name="user_bio" rows="4"></textarea>
//               </fieldset>

//               <label htmlFor="date">Service Date</label>
//                 <input type="date" id="date" name="service_date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} required />

//                 <label htmlFor="time">Service Time</label>
//                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                   {/* Hour dropdown (1 to 12) */}
//                   <select
//                     value={selectedHour}
//                     onChange={(e) => setSelectedHour(e.target.value)}
//                     style={{ marginRight: '10px' }}
//                     required
//                   >
//                     {Array.from({ length: 12 }, (_, i) => i + 1).map((hour) => (
//                       <option key={hour} value={hour}>{hour}</option>
//                     ))}
//                   </select>

//                   {/* Minute dropdown */}
//                   <select
//                     value={selectedMinute}
//                     onChange={(e) => setSelectedMinute(e.target.value)}
//                     style={{ marginRight: '10px' }}
//                     required
//                   >
//                     {['00', '15', '30', '45'].map((minute) => (
//                       <option key={minute} value={minute}>{minute}</option>
//                     ))}
//                   </select>

//                   {/* AM/PM dropdown */}
//                   <select
//                     value={selectedPeriod}
//                     onChange={(e) => setSelectedPeriod(e.target.value)}
//                     style={{ marginLeft: '10px', width: '80px' }}
//                     required
//                   >
//                     <option value="AM">AM</option>
//                     <option value="PM">PM</option>
//                   </select>
//                 </div>

//               <button type="submit">Book Now</button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BookNow;

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BookNow = () => {
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedHour, setSelectedHour] = useState('1');
  const [selectedMinute, setSelectedMinute] = useState('00');
  const [selectedPeriod, setSelectedPeriod] = useState('AM');
  const [comments, setComments] = useState('');
  const [home, setHome] = useState('');

  useEffect(() => {
    // Fetch the services from the API
    axios.get('https://feniceshieldchemical.bwsoft.in/api/api/services/')
      .then(response => {
        setServices(response.data);
      })
      .catch(error => {
        console.error('Error fetching services:', error);
      });
  }, []);

  // Convert time to 24-hour format before submitting
  const convertTimeTo24Hour = (hour, minute, period) => {
    let hours = parseInt(hour, 10);

    if (period === 'PM' && hours < 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    return `${hours.toString().padStart(2, '0')}:${minute}`;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Convert time to 24-hour format
    const time24 = convertTimeTo24Hour(selectedHour, selectedMinute, selectedPeriod);

    const bookingData = {
      service_id: selectedService,
      service_date: selectedDate,
      service_time: time24, // Convert time to 24-hour format
      comments: comments,
      home: home
    };

    // POST request to the API
    axios.post('https://feniceshieldchemical.bwsoft.in/api/api/book-now/', bookingData)
      .then(response => {
        alert('Booking successful!');
        console.log(response.data); // Handle the response if needed
      })
      .catch(error => {
        console.error('Error submitting booking:', error);
        alert('There was an error submitting the booking. Please try again.');
      });
  };

  return (
    <div>
      <div className="banner">
        <img src="assets/img/about.jpg" alt="About" />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={handleSubmit}>
              <h1>Book Service</h1>

              <fieldset>
                <label htmlFor="job">Select service</label>
                <select id="job" name="user_job" value={selectedService} onChange={(e) => setSelectedService(e.target.value)} required>
                  <optgroup label="Services">
                    {services.length > 0 ? (
                      services.map(service => (
                        <option key={service.id} value={service.id}>
                          {service.name}
                        </option>
                      ))
                    ) : (
                      <option>Loading services...</option>
                    )}
                  </optgroup>
                </select>

                <legend>
                  <span className="number">1</span> Fill the form
                </legend>

                <label htmlFor="date">Service Date</label>
                <input type="date" id="date" name="service_date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} required />

                <label htmlFor="time">Service Time</label>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {/* Hour dropdown (1 to 12) */}
                  <select
                    value={selectedHour}
                    onChange={(e) => setSelectedHour(e.target.value)}
                    style={{ marginRight: '10px' }}
                    required
                  >
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((hour) => (
                      <option key={hour} value={hour}>{hour}</option>
                    ))}
                  </select>

                  {/* Minute dropdown */}
                  <select
                    value={selectedMinute}
                    onChange={(e) => setSelectedMinute(e.target.value)}
                    style={{ marginRight: '10px' }}
                    required
                  >
                    {['00', '15', '30', '45'].map((minute) => (
                      <option key={minute} value={minute}>{minute}</option>
                    ))}
                  </select>

                  {/* AM/PM dropdown */}
                  <select
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(e.target.value)}
                    style={{ marginLeft: '10px', width: '80px' }}
                    required
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>

                <label htmlFor="comments">Comments</label>
                <input type="text" id="comments" name="comments" value={comments} onChange={(e) => setComments(e.target.value)} required />

                <label htmlFor="home">Home</label>
                <input type="text" id="home" name="home" value={home} onChange={(e) => setHome(e.target.value)} required />

                <label htmlFor="bio">Bio:</label>
                <textarea id="bio" name="user_bio" rows="4"></textarea>
              </fieldset>

              <button type="submit">Book Now</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookNow;
